import React from 'react';
import { idDeOpcion } from '../data/flows';
import BrujulaGuia from './BrujulaGuia';

// La oferta apilada del producto por el que entró la persona (spec v4, «La página final, a lo Hormozi»):
// qué te llevás · garantía · escasez · precio · un solo botón. El resultado soñado es el mensaje del nodo,
// arriba. Lo que An todavía no escribió no se muestra (An, 04/11: «sacá de la landing las notas»): nunca
// se completa con algo inventado ni se deja a la vista un aviso interno.

// Por qué ese nivel, dicho con la respuesta de la persona.
const porQue = (equipo) => (idDeOpcion('ia_equipo', equipo) === 'solo'
  ? 'Si trabajás por tu cuenta'
  : `Para un equipo ${equipo.toLowerCase().replace(/^más/, 'de más')} personas`);

const OfertaProducto = ({ oferta, nivel, equipo, boton }) => {
  const [producto, ...partes] = oferta.titulo.split(' · ');
  const resto = partes.join(' · ');
  const datos = [['Garantía', oferta.garantia], ['Lugares', oferta.escasez], ['Precio', oferta.precio]]
    .filter(([, valor]) => valor);
  // En la banda de la oferta: a la izquierda qué es y para quién; a la derecha lo que incluye, numerado; abajo
  // las condiciones en fila y el botón (04/11, «sigue siendo un word»).
  return (
    <div className={`gh-oferta${oferta.incluye || oferta.secciones ? ' gh-oferta--lista' : ''}`} aria-labelledby="gh-c-oferta">
      <div className="gh-oferta__cabeza">
        {nivel && equipo && <p className="gh-volanta">{porQue(equipo)}</p>}
        {/* «Agencia · Plan Asistencia · Cohorte fundadora»: el producto grande y el resto como segunda línea */}
        <div className="gh-guia"><BrujulaGuia /><h2 id="gh-c-oferta" className="gh-oferta__titulo">{producto}{resto && <span className="gh-oferta__nivel">{resto}</span>}</h2></div>
        {oferta.bajada && <p className="gh-oferta__bajada">{oferta.bajada}</p>}
        {oferta.combina && <p>{oferta.combina}</p>}
      </div>
      {(oferta.incluye || oferta.secciones) && (
        <div className="gh-oferta__cuerpo">
          {oferta.incluye && <>
            <h3 className="gh-oferta__sub">Qué incluye</h3>
            <ol className="gh-oferta__lista">{oferta.incluye.map(i => <li key={i}>{i}</li>)}</ol>
          </>}
          {oferta.secciones?.map(sec => (
            <React.Fragment key={sec.titulo}>
              <h3 className="gh-oferta__sub">{sec.titulo}</h3>
              <ol className="gh-oferta__lista">{sec.items.map(i => <li key={i}>{i}</li>)}</ol>
            </React.Fragment>
          ))}
        </div>
      )}
      {oferta.formatos && (
        <div className="gh-formatos">
          {oferta.formatos.map(f => (
            <div key={f.nombre} className="gh-formato">
              <h3 className="gh-formato__nombre">{f.nombre}</h3>
              {f.precio && <p className="gh-formato__precio">{f.precio}</p>}
              <ul className="gh-formato__detalle">{f.detalle.map(d => <li key={d}>{d}</li>)}</ul>
              <a className="guia-btn guia-btn--solido gh-formato__accion" href={f.accion.url} target="_blank" rel="noopener noreferrer">{f.accion.texto}</a>
            </div>
          ))}
        </div>
      )}
      {oferta.ejemplos && (
        <div className="gh-oferta__ejemplos">
          <h3 className="gh-oferta__sub">{oferta.ejemplosTitulo}</h3>
          <ul className="gh-ejemplos">{oferta.ejemplos.map(e => <li key={e}>«{e}»</li>)}</ul>
        </div>
      )}
      {oferta.cohorte && (
        // La cohorte fundadora, como algo limitado: los lugares dibujados, lo que gana y lo que se pide (An, 04/11).
        <div className="gh-cohorte" aria-labelledby="gh-c-cohorte">
          <div className="gh-cohorte__cabeza">
            <h3 id="gh-c-cohorte" className="gh-cohorte__titulo">{oferta.cohorte.titulo}</h3>
            {oferta.cohorte.bajada && <p className="gh-cohorte__bajada">{oferta.cohorte.bajada}</p>}
            {oferta.cohorte.fechas && <p className="gh-cohorte__fechas">{oferta.cohorte.fechas}</p>}
            <ol className="gh-cohorte__lugares" aria-label={`${oferta.cohorte.lugares} lugares`}>
              {Array.from({ length: oferta.cohorte.lugares }).map((_, i) => <li key={i}><span>{i + 1}</span></li>)}
            </ol>
          </div>
          <div className="gh-cohorte__cuerpo">
            <ul className="gh-cohorte__gana">{oferta.cohorte.gana.map(g => <li key={g}>{g}</li>)}</ul>
            <p className="gh-cohorte__pide">{oferta.cohorte.pide}</p>
            {boton}
          </div>
        </div>
      )}
      {/* El trato: condiciones a la izquierda y el botón a la derecha, en un solo panel */}
      {(datos.length > 0 || oferta.noEs || oferta.nota || (!oferta.formatos && !oferta.cohorte)) && (
        <div className="gh-oferta__trato">
          {/* Sin condiciones escritas, el panel lleva solo el botón: un hueco vacío arriba se leía como algo que faltaba */}
          {(datos.length > 0 || oferta.noEs || oferta.nota) && <div className="gh-oferta__condiciones">
            {datos.length > 0 && (
              <dl className="gh-oferta__datos">
                {datos.map(([titulo, valor]) => <div key={titulo}><dt>{titulo}</dt><dd>{valor}</dd></div>)}
              </dl>
            )}
            {oferta.noEs && <p className="gh-nota">{oferta.noEs}</p>}
            {oferta.nota && <p className="gh-nota">{oferta.nota}</p>}
          </div>}
          {/* Con formatos, cada uno trae su botón; el contacto queda en el chat de la esquina (An, 04/11). */}
          {!oferta.formatos && !oferta.cohorte && <div className="gh-oferta__boton">{boton}</div>}
        </div>
      )}
    </div>
  );
};

export default OfertaProducto;
